
    export default {
        data() {
            return {
                swiperOptions: {
                    loop: true,
                    speed: 750,
                    spaceBetween: 30,
                    slidesPerView: 5,
                    autoplay: true,

                    // Responsive breakpoints
                    breakpoints: {
                        320: {
                            slidesPerView: 1
                        },
                        480: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 3
                        },
                        992: {
                            slidesPerView: 4
                        }
                    }
                },

                brandLogos: [
                    {
                        imgSrc: "/images/brand-logo/ChargePoint_logo1.png",
                        alt: "brand logo"
                    },
                    {
                        imgSrc: "/images/brand-logo/clippercreek-logo1.png",
                        alt: "brand logo"
                    },
                    {
                        imgSrc: "/images/brand-logo/Leviton-Logo1.png",
                        alt: "brand logo"
                    },
                    {
                        imgSrc: "/images/brand-logo/SemaConnectlogo1.png",
                        alt: "brand logo"
                    },
                ]
            }
        },
    };
